export const CREATE_CONTACT_DEAD_KEYS = [
  'claim_id',
  'bank_proof_document_id',
  'claim_document_or_upload_file',
  'file_size',
  'remove_bank_proof_document',
  'au_tfn_document_id',
  'remove_au_tfn_document',
];

// Removes create-dead keys the backend never reads. NOTE: exposure_ids is intentionally NOT here —
// it must survive to handleSubmit, which routes it to the separate claim-contacts endpoint.
export const stripDeadCreateContactKeys = (payload: Record<string, unknown>): Record<string, unknown> => {
  const copy = { ...payload };
  CREATE_CONTACT_DEAD_KEYS.forEach((k) => delete copy[k]);
  return copy;
};

// Splits the prepared payload into the /contacts body (without exposure_ids) and the exposure_ids
// that the claim-contacts endpoint consumes separately.
export const splitCreateContactPayload = (
  payload: Record<string, unknown>
): { contactPayload: Record<string, unknown>; exposureIds: unknown } => {
  const { exposure_ids: exposureIds, ...contactPayload } = payload;
  return { contactPayload, exposureIds };
};
